(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["1000marcas-account-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mm-account-highlight')) {
    customElements.define('mm-account-highlight', class extends HTMLElement {
      connectedCallback() {
        this.account = this.querySelector('shopify-account');
        this.template = this.querySelector('template[data-mm-company-registration]');
        if (!this.account || !this.template) return;
        this.controller = new AbortController();
        this.refresh = () => {
          if (!this.accountRoot) return;
          const nav = this.accountRoot.querySelector('nav.account__shortcuts');
          if (!nav) return;
          let target;
          try {
            target = new URL(this.template.dataset.companyPath, location.origin);
          } catch {
            return;
          }
          if (!this.accountRoot.querySelector('style[data-mm-company-registration]')) {
            const style = document.createElement('style');
            style.dataset.mmCompanyRegistration = '';
            style.textContent = `
              .mm-company-registration {
                display: block;
                box-sizing: border-box;
                width: 100%;
                padding: 0 0 16px;
                color: var(--shopify-account-color-text);
                font-family: var(--shopify-account-font-body);
                font-size: 14px;
                font-weight: 400;
                line-height: 1.4;
              }
              .mm-company-registration__button {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
                box-sizing: border-box;
                width: 100%;
                min-height: 48px;
                margin: 0;
                padding: 12px 16px;
                border: 1px solid var(--shopify-account-color-border);
                border-radius: var(--shopify-account-radius-button, 10px);
                background: color-mix(in srgb, var(--shopify-account-color-border) 40%, transparent);
                color: var(--shopify-account-color-text);
                font: inherit;
                font-weight: 500;
                line-height: 1.4;
                text-align: center;
                text-decoration: none;
                cursor: pointer;
              }
              .mm-company-registration__button:hover {
                background: color-mix(in srgb, var(--shopify-account-color-border) 60%, transparent);
              }
              .mm-company-registration__button:focus-visible {
                outline: 2px solid rgba(var(--color-heading));
                outline-offset: 2px;
              }
              .mm-company-registration__icon {
                display: inline-flex;
                width: 18px;
                height: 18px;
                flex: 0 0 18px;
                color: rgba(var(--color-heading));
              }
              .mm-company-registration__icon svg,
              .mm-company-registration__check svg {
                display: block;
                width: 100%;
                height: 100%;
              }
              .mm-company-registration__benefits {
                display: grid;
                gap: 8px;
                margin: 14px 0 0;
                padding: 0;
                list-style: none;
              }
              .mm-company-registration__benefits li {
                display: flex;
                align-items: flex-start;
                gap: 8px;
                margin: 0;
                padding: 0;
                font-size: 13px;
                font-weight: 400;
                line-height: 1.4;
              }
              .mm-company-registration__check {
                display: inline-flex;
                width: 15px;
                height: 15px;
                flex: 0 0 15px;
                margin-top: 2px;
                color: rgba(var(--color-heading));
              }
              .mm-company-registration__note {
                margin: 10px 0 0;
                color: var(--shopify-account-color-text);
                font-size: 12px;
                font-weight: 400;
                line-height: 1.4;
              }
              .account__item-wrapper.mm-company-registration-original {
                display: none !important;
              }
            `;
            this.accountRoot.appendChild(style);
          }
          let block = this.accountRoot.querySelector('.mm-company-registration');
          if (!block) {
            block = this.template.content.firstElementChild.cloneNode(true);
            nav.before(block);
          } else if (block.nextElementSibling !== nav) {
            nav.before(block);
          }
          nav.querySelectorAll('a[href]').forEach(link => {
            let matches = false;
            try {
              const url = new URL(link.getAttribute('href'), location.origin);
              matches = url.origin === target.origin && url.pathname === target.pathname;
            } catch {
              matches = false;
            }
            const wrapper = link.closest('.account__item-wrapper');
            if (wrapper) wrapper.classList.toggle('mm-company-registration-original', matches);
          });
        };
        this.install = () => {
          const root = this.account.shadowRoot;
          if (!root) return;
          if (this.accountRoot !== root) {
            this.observer?.disconnect();
            this.accountRoot = root;
            this.observer = new MutationObserver(this.refresh);
            this.observer.observe(root, { childList: true, subtree: true });
          }
          this.refresh();
        };
        this.account.addEventListener('open', this.install, { signal: this.controller.signal });
        customElements.whenDefined('shopify-account').then(() => {
          if (this.isConnected) this.install();
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.accountRoot = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
